var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pwa-email-verification"},[_c('div',{staticClass:"subtitle-text"},[_vm._v(_vm._s(_vm.subtitle))]),_c('img',{staticClass:"margin-top-50 margin-bottom-20",attrs:{"src":_vm.getBrandImageSrc('message_duotone.svg'),"alt":"message"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }